// removed by extract-text-webpack-plugin
module.exports = {"Layout":"Layout__Layout--1WKx0"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 77
// module chunks = 0